const baseURL = "https://api.scottsautter.com";
// const baseURL = "http://localhost:8080";

export const ROUTE = {
  HOMEPAGE: { url: "/" },
  BETA: { url: "/beta" },
  CRICKET_PAGE: { url: "/cricket" },
  X01_PAGE: { url: "/x01" },
  HALVES_PAGE: { url: "/halves" },
  HALFS_PAGE: { url: "/halfs" },
  JOIN_CRICKET: { method: 'get', url: `${baseURL}/match/cricket` },
  JOIN_301: { method: 'get', url: `${baseURL}/match/301` },
  JOIN_501: { method: 'get', url: `${baseURL}/match/501` },
  CREATE_PRIVATE: {
    method: 'post', url: `${baseURL}/match/private`
  },
  CRICKET_HIT: { method: 'post', url: `${baseURL}/game/cricket` },
  X01_HIT: { method: 'post', url: `${baseURL}/game/x01` },
  GET_MATCH_STATE: { method: 'get', url: (id: string) => `${baseURL}/match/${id}` },
  GET_GAME_STATE: { method: 'get', url: (id: string) => `${baseURL}/game/${id}` },
  JOIN_PRIVATE: { method: 'get', url: (roomCode: string) => `${baseURL}/match/private/${roomCode}` },
  END_LEG: { method: 'post', url: `${baseURL}/game/end/leg` },
  UNDO_REQUEST: { method: 'post', url: `${baseURL}/game/request/undo` },
  CONTINUE_REQUEST: { method: 'post', url: `${baseURL}/game/request/continue` },
  RESTART_REQUEST: { method: 'post', url: `${baseURL}/game/request/restart` },
  DENY_UNDO: { method: 'post', url: `${baseURL}/game/deny/undo` },
  PLAYER_LEAVE: { method: 'post', url: `${baseURL}/game/leave` },
  NUM_OF_PLAYERS: { method: 'get', url: (id: string) => `${baseURL}/players/${id}` },
}